export default __webpack_public_path__ + "static/media/logo_2.0d71d089.png";